import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PlantModelElement,
  PlantGroupElement,DivisionElement
} from '../models/O3AdministrationModels/plant-model';


@Injectable({
  providedIn: 'root',
})
export class  EnterPriseGroupService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroupList(data: any): Observable<PlantModelElement[]> {
    return this.http.post<PlantModelElement[]>(this.baseUrl + 'PlantModal/GetGroupList', data);
  }
  submitGroup(data: any): Observable<DivisionElement[]> {
    return this.http.post<DivisionElement[]>(this.baseUrl + 'DivisionModule/SumbitDivision', data);
  }
  getTreeModal(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl + 'Common/GetTreeModal', data);
  }
  getTreePlantModel(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl + 'Common/GetTreePlantModel', data);
  }
  getTreeModalComponent(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl + 'CIL/GetCompModelTreeForCIL', data);
  }
  addPlantModalTree(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'PlantModal/SumbitChildModel', data);
    return this.http.post<any>(this.baseUrl + 'DivisionModule/SumbitChildModel', data);
  }
  getPlantModalById(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'DivisionModule/GetChildModel', data);
  }
  GetMenuAccess(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Account/GetMenuAccess', data);
  }
  GetQualityGridAnalysis(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityGridAnalysis', data);
  }
  GetQualityGridAnalysisChartData(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'QualityGradeAnalysis/GetQualityGridAnalysisChartData',
      data
    );
  }
  GetQualityJumboTime(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityJumboTime', data);
  }

  getDivisionListByPlant(data: any): Observable<DivisionElement[]> {
    return this.http.post<DivisionElement[]>(this.baseUrl + 'DivisionModule/GetPlantModel', data);
  }

  getDepartment(data: any): Observable<any[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl +'DivisionModule/GetAuthDB_Department', data);
  }
  GetQualityJumboTimeFH(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityJumboTimeFH', data);
  }
  getUnit(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'QualityGradeAnalysis/GetUnit');
  }
  GetQualityGridAnalysisFH(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityGridAnalysisFH', data);
  }
  getMasterSlaveUnits(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'DivisionModule/GetMasterSlaveUnit', data);
  }
}
